import script from "./TextWriteWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextWriteWindow.vue?vue&type=script&setup=true&lang=ts"

import "./TextWriteWindow.vue?vue&type=style&index=0&id=30bcf916&lang=scss"

const __exports__ = script;

export default __exports__